import { lazy } from "react";

export const getLazyComponent = (dynamicImportFactory) => {
  const Component = lazy(dynamicImportFactory);
  Component.preload = dynamicImportFactory;
  return Component;
};
